import { defineMessages } from 'react-intl';

export const i18n: {
	embeddedContentTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	embeddedContentTitle: {
		id: 'iframe-macro.embedded-content-title',
		defaultMessage: 'Embedded iframe content',
		description: 'Fallback accessible title for an iframe macro when the macro title is empty.',
	},
	error: {
		id: 'iframe-macro.error',
		defaultMessage: "We're unable to display the iframe. Refresh to try again",
		description: 'Generic error message displayed when the iframe macro fails to render.',
	},
});
